import styled from 'styled-components';

import { Message } from '@dreryk/react-components';

export const StyledPatientAddressIncompleteStatus = styled(Message)`
   grid-column: span 2;
`;
